module.exports = __webpack_public_path__ + "img/owncheck.a134b275.gif";